import { Record } from 'immutable';

const DashboardFilterStateRecord = Record({
  completedAndUnpaid: true,
  missingAgency: true

});

export class DashboardFilterState extends DashboardFilterStateRecord {
  completedAndUnpaid: boolean;
  missingAgency: boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/dashboard/dashboard-page/dashboard-filter.ts